import { fromLonLat } from 'ol/proj';

/**
 * 로봇 마커 관리 Feature
 */
class RobotFeature {
  constructor(createOverlay, map) {
    this.createOverlay = createOverlay;
    this.map = map;
    this.robots = {};
  }

  /**
   * 로봇 마커 추가 또는 업데이트
   * @param {string} robotId - 로봇 ID
   * @param {HTMLElement} element - 마커 DOM 엘리먼트
   * @param {Object} position - { lat, lng } 좌표
   */
  add(robotId, element, { lat, lng }) {
    const position = fromLonLat([lng, lat]);

    // 기존 로봇 마커
    if (this.robots[robotId]) {
      this.robots[robotId].setPosition(position);
    }
    // 신규 로봇 마커
    else {
      this.robots[robotId] = this.createOverlay({
        id: `robots/${robotId}`,
        element,
        position,
        positioning: 'top-center',
        offset: [0, -24],
        stopEvent: false,
        insertFirst: false,
      });
      this.map.addOverlay(this.robots[robotId]);
    }
  }

  /**
   * 로봇 마커 제거
   * @param {string} robotId - 로봇 ID
   */
  remove(robotId) {
    if (!this.robots[robotId]) return;

    this.map.removeOverlay(this.robots[robotId]);
    delete this.robots[robotId];
  }

  /**
   * 모든 로봇 마커 가져오기
   * @returns {Object} 로봇 마커 객체
   */
  getAll() {
    return this.robots;
  }
}

export default RobotFeature;
